export default __webpack_public_path__ + "img/7f1d0696acc286384e4ffc99859faa26.svg";